import { render, staticRenderFns } from "./UsersInRole.vue?vue&type=template&id=01fca750&scoped=true&"
import script from "./UsersInRole.vue?vue&type=script&lang=js&"
export * from "./UsersInRole.vue?vue&type=script&lang=js&"
import style0 from "./UsersInRole.vue?vue&type=style&index=0&id=01fca750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fca750",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01fca750')) {
      api.createRecord('01fca750', component.options)
    } else {
      api.reload('01fca750', component.options)
    }
    module.hot.accept("./UsersInRole.vue?vue&type=template&id=01fca750&scoped=true&", function () {
      api.rerender('01fca750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/permissions/UsersInRole.vue"
export default component.exports